export const DEFAULT_PAGE_SIZE = 10;

export const LANGUAGE = {
  RO: "RO",
  BG: "BG",
  EN: "EN",
  ro: "ro",
  bg: "bg",
  en: "en",
};
